export const siteUrl =
  process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, '') || 'https://vakuutuslaskuri.fi';

export const localePaths = [
  '',
  '/vertailu',
  '/vertailu/autovakuutus',
  '/vertailu/autovakuutus/tiedot',
  '/autovakuutus',
  '/autovakuutus/tayskasko-paras-turva-ajoneuvollesi',
  '/autovakuutus/liikennevakuutus-pakollinen-turva-autoilijalle',
  '/autovakuutus/auton-vakuuttaminen',
  '/autovakuutus/autovakuutusten-merkittavimmat-erot',
  '/kotivakuutus',
  '/kotivakuutus/kotivakuutuksen-turvan-tarkistaminen-ja-kilpailuttaminen',
  '/kotivakuutus/kotivakuutuksen-merkittavimmat-erot',
  '/kotivakuutus/kotivakuutuksen-hintaerot',
  '/kotivakuutuksen-turvan-tarkistaminen-ja-kilpailuttaminen',
  '/kotivakuutuksen-merkittavimmat-erot',
  '/kotivakuutuksen-hintaerot',
  '/lemmikkivakuutus',
  '/lemmikkielainvakuutus',
  '/ukk',
  '/tietoa-meista',
  '/rekisteriseloste',
  '/tietosuoja',
  '/yhteystiedot',
  '/asiakastuki',
  '/mediassa',
  '/blogi',
];
